import { useState } from 'react';

export type SetStateInitialValue<T> = T | (() => T);

export const useStateMap = <Key extends string, Value>(
  initialValue?: SetStateInitialValue<Map<Key, Value>>
) => {
  const [state, setState] = useState(initialValue || new Map<Key, Value>());

  /**
   * TODO: do not mutate state
   * create a new Map, modify and return it
   *
   * currently it breaks unit tests in AddressList
   */
  const setMapEntry = (key: Key, value: Value) => {
    state.set(key, value);
    setState(new Map(state));

    return state;
  };

  return [state, setMapEntry] as const;
};
